
import { withStyles, createStyles } from "@material-ui/core/styles";

export const styles = (theme) => createStyles({
    target: {
        border: "2px dashed gray",
        margin: theme.spacing(1),
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        flexGrow: 1
    },
    paper: {
        display: "flex",
        flexFlow: "row nowrap"
    },
    input: {
        display: "none"
    },
    displayMessage: {
        textAlign: "center"
    }
});

export const withStylesApplied = withStyles(styles);
